export const COP30_OUTCOME_ID = {
  COLLAPSE: 'collapse',
  MODEST: 'modest',
  AMBITIOUS: 'ambitious'
};

export const COP30_OUTCOMES = [
  {
    id: COP30_OUTCOME_ID.COLLAPSE,
    bonusMultiplier: 0.5,
    penaltyMultiplier: 0.5,
    headline: 'Summit collapses',
    narrative: 'Weak climate action. Clean energy support is halved (0.5x), and weak enforcement softens carbon penalties to 0.5x.'
  },
  {
    id: COP30_OUTCOME_ID.MODEST,
    bonusMultiplier: 1.0,
    penaltyMultiplier: 1.0,
    headline: 'Modest agreement reached',
    narrative: 'Standard tax and bonus apply.'
  },
  {
    id: COP30_OUTCOME_ID.AMBITIOUS,
    bonusMultiplier: 1.5,
    penaltyMultiplier: 1.5,
    headline: 'Historic ambitious targets adopted',
    narrative: 'Tax and bonus multiplied by 1.5x.'
  }
];
